// extracted by mini-css-extract-plugin
module.exports = {"button":"OrganicButton_button__dK_OL","selected":"OrganicButton_selected__Rfl7w"};